import moment from 'moment';
import ReactSelectFormatter from "./ReactSelectFormatter";
import FormDataFormatter from "./FormDataFormatter";
import {DATE_TIME_FORMAT} from '../components/helpers/DateHelper';

const OPTIONAL_FIELDS = [
    'manufacturer',
    'model',
    'year',
    'videoLink',
    'vimeoId',
    'link',
    'images',
    'contactPersonId'
];

class ProductFormSerializer {
    static serialize(product) {
        let result = {
            id: product.id,
            contactPersonId: parseInt(product.contactPersonId) || '',
            categoryIds: product.categoryIds || [],
            publicationType: product.sellType,
            title: product.heading,
            description: product.description,
            manufacturer: product.producer,
            model: product.model,
            videoLink: product.youtubeId,
            vimeoId: product.vimeoId,
            link: product.referenceNumber,
            images: product.images,
            files: product.files,
            defaultImageIds: product.defaultImageIds,
            defaultFileIds: product.defaultFileIds,
            isCommentsAllowed: product.isCommentsAllowed || false,
        };

        result = this._assignPrice(result, product);
        this._deleteEmptyOptionalValues(result);
        return FormDataFormatter.getFormData({...result});
    }

    static _assignPrice(result, formFields) {
        if (formFields.amount !== undefined &&
            formFields.currencyId !== undefined &&
            formFields.priceTypeId !== undefined) {
            return {
                ...result,
                priceAmount: formFields.amount,
                currencyId: formFields.currencyId,
                priceTypeId: formFields.priceTypeId
            };
        }
        return result
    }

    static _deleteEmptyOptionalValues(result) {
        Object.keys(result).forEach((key) => {
            if (
                OPTIONAL_FIELDS.indexOf(key) !== -1 &&
                result[key] === undefined ||
                result[key] === "" ||
                result[key] === null
            ) {
                delete result[key];
            }
        });
    }

    static _unserializePrice(result, product) {
        if (product.priceType !== null && product.currency !== null) {
            result.amount = product.priceAmount;
            result.currencyId = product.currency.id;
            result.priceTypeId = product.priceType.id;
        } else {
            result.amount = null;
            result.currencyId = 1;
            result.priceTypeId = 3;
        }
    }


    static unserialize(product) {
        if(!product.id) {
            return product;
        }

        let formattedProduct = {...product};
        if (formattedProduct.images instanceof Object) {
            if (!(formattedProduct.images instanceof Array)) {
                formattedProduct.images = Object.values(formattedProduct.images);
            }

            formattedProduct.defaultImages = formattedProduct.images;
            formattedProduct.defaultImageIds = formattedProduct.defaultImages.map(image => image.id);
        }
        else {
            formattedProduct.images = formattedProduct.defaultImages = formattedProduct.defaultImageIds = [];
        }

        if (formattedProduct.files instanceof Object) {
            if (!(formattedProduct.files instanceof Array)) {
                formattedProduct.files = Object.values(formattedProduct.files);
            }

            formattedProduct.defaultFiles = formattedProduct.files;
            formattedProduct.defaultFileIds = formattedProduct.defaultFiles.map(file => file.id);
        }
        else {
            formattedProduct.files = formattedProduct.defaultFiles = formattedProduct.defaultFileIds = [];
        }

        let result = {
            id: product.id,
            contactPersonId: product.contactPerson ? product.contactPerson.id : null,
            isCommentsAllowed: product.isCommentsAllowed,
            categoryIds: product.categories.map(c => c.id),
            sellType: product.publicationType,
            heading: product.title,
            description: product.description,
            producer: product.manufacturer,
            model: product.model,
            // FIXME should be youtube or vimeo
            youtubeId: product.videoLink,
            vimeoId: product.vimeoId,
            referenceNumber: product.link,
            images: [],
            defaultImages: formattedProduct.defaultImages,
            defaultImageIds: formattedProduct.defaultImageIds,
            files: [],
            defaultFiles: formattedProduct.defaultFiles,
            defaultFileIds: formattedProduct.defaultFileIds,
        };

        this._unserializePrice(result, product);

        return result;
    }

    /**
     *
     * @param {string} dateString
     * @returns {integer}
     */
    static getUnixStamp(dateString) {
        return moment(dateString, DATE_TIME_FORMAT).unix();
    }
}

export default ProductFormSerializer;


// WEBPACK FOOTER //
// ./web/src/services/ProductFormSerializer.js